document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('body.blog')) {
        const filterDropdown = document.querySelector('.js-posts-filter-dropdown');
        const sortDropdown = document.querySelector('.js-posts-sort-dropdown');

        // Function to parse URL parameters
        function getUrlParameter(name) {
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
            const results = regex.exec(window.location.href);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        // Check if filter parameter exists in URL and set dropdown value
        const initialFilterTag = getUrlParameter('filter');
        if (initialFilterTag && filterDropdown) {
            const matchingOption = Array.from(filterDropdown.options).find(option => option.value === initialFilterTag);
            if (matchingOption) {
                filterDropdown.value = initialFilterTag;
            }
        }

        // Check if sort parameter exists in URL and set dropdown value
        const initialSortOption = getUrlParameter('sort');
        if (initialSortOption && sortDropdown) {
            const matchingOption = Array.from(sortDropdown.options).find(option => option.value === initialSortOption);
            if (matchingOption) {
                sortDropdown.value = initialSortOption;
            }
        }

        // Handle filter dropdown change
        if (filterDropdown) {
            filterDropdown.addEventListener('change', function () {
                const selectedFilter = this.value;
                const url = new URL(window.location);

                if (selectedFilter) {
                    url.searchParams.set('filter', selectedFilter);
                } else {
                    url.searchParams.delete('filter');
                }

                // Remove page parameters to redirect to the first page
                url.searchParams.delete('page');
                url.searchParams.delete('paged');

                // Remove page from pathname (handles /page/X/ in the URL path)
                url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');

                console.log(url);
                // Preserve sort parameter if it exists
                const sortValue = sortDropdown ? sortDropdown.value : getUrlParameter('sort');
                if (sortValue) {
                    url.searchParams.set('sort', sortValue);
                }

                window.location.href = url.toString();
            });
        }

        // Handle sort dropdown change
        if (sortDropdown) {
            sortDropdown.addEventListener('change', function () {
                const selectedSort = this.value;
                const url = new URL(window.location);

                if (selectedSort) {
                    url.searchParams.set('sort', selectedSort);
                } else {
                    url.searchParams.delete('sort');
                }

                // Remove page from pathname (handles /page/X/ in the URL path)
                url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');

                // Preserve filter parameter if it exists
                const filterValue = filterDropdown ? filterDropdown.value : getUrlParameter('filter');
                if (filterValue) {
                    url.searchParams.set('filter', filterValue);
                }

                window.location.href = url.toString();
            });
        }

    }
});
